import React, { Component } from "react";
import { Tr, Td } from "react-super-responsive-table";

export default class TRowsP extends Component {
  render() {
    const {
      date,
      number_of_cases_pima,
      new_cases_today_pima,
      rate_cases_100k_pima,
      number_of_deaths_pima,
      new_deaths_today_pima,
      rate_deaths_100k_pima,
      percent_positive_pima,
    } = this.props.data;

    if (percent_positive_pima.includes("%")) {
      var pp = percent_positive_pima;
    } else {
      pp = `${percent_positive_pima}%`;
    }
    return (
      <Tr>
        <Td>
          {date.month} / {date.day}
        </Td>
        <Td>
          {number_of_cases_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        <Td>
          {new_cases_today_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        <Td>
          {rate_cases_100k_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        <Td>
          {number_of_deaths_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        <Td>
          {new_deaths_today_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        <Td>
          {rate_deaths_100k_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td>
        {/* <Td>
          {number_of_test_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td> */}
        {/* <Td>
          {new_test_today_pima
            .replace(/,/g, "")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </Td> */}
        {/* <Td>{pp}</Td> */}
      </Tr>
    );
  }
}
